import React, { useEffect, useState } from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    InputAdornment,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { Search } from '@mui/icons-material';
import _debounce from 'lodash.debounce';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';





import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';

import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import VisibilityIcon from '@mui/icons-material/Visibility';
import EditNoteIcon from '@mui/icons-material/EditNote';
import Badge from '@mui/material/Badge';
import axios from "axios";
import swal from "sweetalert";
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


import { useHistory } from "react-router-dom";
import Input from '@mui/material/Input';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';

import PhotoCamera from '@mui/icons-material/PhotoCamera';
import Stack from '@mui/material/Stack';
import AttachmentIcon from '@mui/icons-material/Attachment';
import Grid from '@mui/material/Grid';

const IndexAbstractHomePageSettings = () => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchText, setSearchText] = useState('');
    const [permissions, setrPermissions] = useState([]);
    useEffect(() => {
        axios.get(`api/getpermissionByRole`).then(res => {

            if (res.status === 200) {
                const datad = res.data.data.permissions;
                setrPermissions(datad)

            } else {

            }


        })

    }, []);
    const eventid = localStorage.getItem('eventid');
    const [abstractHomePageSetup, setAbstractHomePageSetup] = useState({});
    const [serverAwsS3error, setServerAwsS3error] = useState("");
    useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const abstractHomePageData = res.data.HomePageSetup;
                const fieldError = res.data.fieldErrors;
                setServerAwsS3error(fieldError);
                setAbstractHomePageSetup(abstractHomePageData);
            }

        })
    }, [eventid]);

    //this is for Storage Server error
    const hasFieldErrors = serverAwsS3error && Object.keys(serverAwsS3error).length > 0;

    

    // const inActiveBooth = (e, id) => {
    //     e.preventDefault();
    //     const thisClicked = e.currentTarget;
    //     thisClicked.innerText = " Deleting..."
    //     axios.get(`api/status-exhibition-booth/${id}`).then(res => {
    //         if (res.data.status === 200) {
    //             //swal("Success", res.data.message, "success");
    //             thisClicked.closest("tr").remove();
    //         }
    //         else if (res.data.status === 404) {
    //             this.innText = "delete";
    //         }
    //     })
    // }
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const [searchTerm, setSearchTerm] = useState('');

    const filteredPosts = [];
    if (abstractHomePageSetup) {
        const matchesEventPlace = abstractHomePageSetup.event_place && abstractHomePageSetup.event_place.toString().toLowerCase().includes(searchTerm.toLowerCase());
        const matchesSendEmail = abstractHomePageSetup.send_email && abstractHomePageSetup.send_email.toLowerCase().includes(searchTerm.toLowerCase());

        if (matchesEventPlace || matchesSendEmail) {
            filteredPosts.push(abstractHomePageSetup);
        }
    }

    const totalRecords = abstractHomePageSetup.length;
    const filteredRecordsCount = filteredPosts.length;





    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    let backGroundButtonByEvent = "";
    if (eventid) {
        backGroundButtonByEvent = `${abstractHomePageSetup.color_code_two}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
    }


    return (
        <div style={{ margin: '1%', width: '100vw', marginLeft: '0%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>

                <Card sx={{ width: '82vw', float: 'center' }} >

                    <CardContent >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Typography component="h1" variant="h5">
                                Home Page Setting
                            </Typography>
                            Total Records: {totalRecords} | Filtered Records: {filteredRecordsCount}
                            <Grid item xs={8} >
                                <TextField
                                    fullWidth
                                    label="Filter By: code ,type ,exhibitor , boothcategory"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </Grid>
                        </div>
                        <div sx={{ m: 2, color: '#000000' }} >

                            <Button sx={{
                                float: 'right',
                                marginRight: '1%',
                                marginTop: '2%',
                                backgroundColor: backGroundButtonByEvent,
                                ":hover": {
                                    color: "white"
                                }
                            }}
                                color='success'
                                size='small'
                                variant='contained'
                                component={Link}
                                to="/admin/abstract/home-page">
                               Add / Update
                            </Button> 
                        </div>
                        <Box component="form" noValidate sx={{ mt: 3 }}>
                            {hasFieldErrors && (
                                <Grid item xs={8}>
                                    <div style={{ color: 'red', textAlign: 'center', margin: '20px 0' }}>
                                    There are AWS S3 server issues affecting some fields. Please check!
                                    </div>
                                </Grid>
                            )}

                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell > #</TableCell>
                                            <TableCell align="left">Color Code 1</TableCell>
                                            <TableCell align="left">Color Code 2</TableCell>
                                            <TableCell align="left">Color Code 3</TableCell>
                                            <TableCell align="left">Event Place	</TableCell>
                                            <TableCell align="left">Email</TableCell>
                                            <TableCell align="left">Emergency Call</TableCell>
                                            <TableCell align="left">Instagram</TableCell>
                                            <TableCell align="left">FaceBook</TableCell>
                                            <TableCell align="left">LinkedIn</TableCell>
                                            <TableCell align="left">Twitter</TableCell>
                                            {/* {
                                            permissions['p_exhibition-booth-edit'] === true ?
                                            <TableCell align="left">Action</TableCell>:
                                            permissions['p_exhibition-booth-delete'] === true ?
                                            <TableCell align="left">Action</TableCell>:<TableCell align="left"></TableCell> } */}


                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        <TableRow key={abstractHomePageSetup.id}>
                                            <>
                                                <TableCell key={abstractHomePageSetup.id}>{abstractHomePageSetup.id}</TableCell>
                                                <TableCell >{abstractHomePageSetup.color_code}</TableCell>
                                                <TableCell >{abstractHomePageSetup.color_code_two}</TableCell>
                                                <TableCell >{abstractHomePageSetup.color_code_three}</TableCell>
                                                <TableCell >{abstractHomePageSetup.event_place}</TableCell>
                                                <TableCell > {abstractHomePageSetup.send_email}</TableCell>
                                                <TableCell >{abstractHomePageSetup.call_emergency}</TableCell>
                                                <TableCell >{abstractHomePageSetup.Instagram_link}</TableCell>
                                                <TableCell >{abstractHomePageSetup.facebook_link}</TableCell>
                                                <TableCell >{abstractHomePageSetup.linkedin_link}</TableCell>
                                                <TableCell >{abstractHomePageSetup.twitter_link}</TableCell>


                                                {/* <TableCell >
                                                        {
                                                            permissions['p_exhibition-booth-edit'] === true ?
                                                        <Button sx={{ marginRight: 1, ":hover": { color: "white" } ,backgroundColor: '#145348'}}
                                                            color='primary'
                                                            size='small'
                                                            variant='contained'
                                                            component={Link}
                                                            to={`/admin/exhibition/edit-booth/${abstractHomePageSetup.id}`}>
                                                            <EditNoteIcon />
                                                        </Button>:""}
                                                        {
                                                            permissions['p_exhibition-booth-delete'] === true ?
                                                        <Button sx={{ ":hover": { color: "white" },backgroundColor: '#145348' }}
                                                            color='primary'
                                                            size='small'
                                                            variant='contained'
                                                            onClick={(e) => inActiveBooth(e, abstractHomePageSetup.id)}>
                                                            <DeleteIcon />
                                                        </Button>:""}
                                                        </TableCell> */}

                                            </>
                                        </TableRow>

                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[10, 25, 50, 100, 500, 1000]}
                                    component="div"
                                    count={filteredPosts.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </TableContainer>

                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
}


export default IndexAbstractHomePageSettings;
